import MedicalServicesOutlinedIcon from "@mui/icons-material/MedicalServicesOutlined";
import ScienceOutlinedIcon from "@mui/icons-material/ScienceOutlined";
import BiotechOutlinedIcon from "@mui/icons-material/BiotechOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import GppGoodOutlinedIcon from "@mui/icons-material/GppGoodOutlined";
import AddIcon from "@mui/icons-material/Add";
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";
import EcoOutlinedIcon from "@mui/icons-material/SpaOutlined";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import WaterDropOutlinedIcon from "@mui/icons-material/WaterDropOutlined";
import WbSunnyOutlinedIcon from "@mui/icons-material/WbSunnyOutlined";
import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";
import PercentIcon from "@mui/icons-material/Percent";
import MonitorHeartOutlinedIcon from "@mui/icons-material/MonitorHeartOutlined";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";

const ICONS = {
  stethoscope: MedicalServicesOutlinedIcon, flask: ScienceOutlinedIcon, microscope: BiotechOutlinedIcon, lock: LockOutlinedIcon,
  shield: GppGoodOutlinedIcon, plus: AddIcon, pin: PlaceOutlinedIcon, leaf: EcoOutlinedIcon, person: PersonOutlineIcon, drop: WaterDropOutlinedIcon,
  sun: WbSunnyOutlinedIcon, dollar: PaidOutlinedIcon, percent: PercentIcon, pulse: MonitorHeartOutlinedIcon, play: PlayArrowIcon, hourglass: HourglassEmptyIcon,
};

/** Small icon set used on the homepage; look icons up by name so page data stays plain text. */
export default function Glyph({ name, sx }) {
  const Icon = ICONS[name] || AddIcon;
  return <Icon sx={sx} aria-hidden />;
}
